<ng-container *ngIf="{ category: category$ | async } as data">
  <ng-container *ngIf="data.category && !hasPriceCampaign">
    <ng-container
      *ngTemplateOutlet="
        headerTemplate;
        context: {
          $implicit: {
            bannerImage: bannerImage,
            title: data.category?.name,
            description: data.category?.description,
            class: 'category'
          }
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="!data.category && !hasPriceCampaign && addon">
    <ng-container
      *ngTemplateOutlet="
        headerTemplate;
        context: { $implicit: { bannerImage: bannerImage, title: addon?.title, description: addon?.description, class: 'addon' } }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="hasPriceCampaign">
    <ng-container *ngIf="numberOfSelectedCampaigns === 1 && priceCampaignDetails?.headerTitle; else defaultPriceCampaignDetails">
      <ng-container
        *ngTemplateOutlet="
          headerTemplate;
          context: {
            $implicit: {
              bannerImage: priceCampaignDetails?.headerImage,
              title: priceCampaignDetails?.headerTitle,
              description: priceCampaignDetails?.headerText,
              class: 'price-campaign'
            }
          }
        "
      >
      </ng-container>
    </ng-container>

    <ng-template #defaultPriceCampaignDetails>
      <ng-container *ngIf="defaultPriceCampaignDetails$ | async as defaultPriceCampaignDetails">
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: {
                bannerImage: defaultPriceCampaignDetails?.headerImage,
                title: defaultPriceCampaignDetails?.headerTitle,
                description: defaultPriceCampaignDetails?.headerText,
                class: 'default-price-campaign'
              }
            }
          "
        ></ng-container>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #headerTemplate let-data>
  <div class="header" [ngClass]="data.class">
    <img *ngIf="!!data?.bannerImage" class="background-image" [pyMedia]="data?.bannerImage" loading="eager" />
    <div class="overlay px-4">
      <h1>{{ data?.title }}</h1>
      <p>{{ data?.description }}</p>
    </div>
  </div>
</ng-template>
